<template>
  <div class="product">
     <header>
    <Navbar />
    </header>
    <div class="product-header">
      <!-- <div class="productBanner">
        <img :src="productBanner" />
      </div> -->
      <div class="product_bannnerText">
        <div>智慧服务</div>
        <div>
          运用互联网、云计算、大数据等技术提供安全适宜的医疗信息技术服务，实现服务前移，帮助护理人员提高工作效率和服务质量，全面提升患者满意度。
        </div>
      </div>
    </div>
    <div class="productCont">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right; " class="a">
          <el-breadcrumb-item :to="{ path: '/productCenter' }"
            >产品中心 >智慧服务></el-breadcrumb-item
          >
          <el-breadcrumb-item v-show="current===1" >智慧门诊</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===2">智慧住院</el-breadcrumb-item>
          <el-breadcrumb-item v-show="current===3">智慧护理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="tabs" style="background-color: #ffffff">
        <div class="tabsCont">
          <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
          </el-radio-group>
          
          <div class="tabTitle">
            <div>产品导航</div>
            <div>智慧服务产品体系</div>
          </div>
          <el-tabs :tab-position="tabPosition">
            <el-tab-pane >
               <span slot="label" @click="tab(1)" >
                <i class="el-icon-caret-right"></i> 智慧门诊
             </span >
              <div class="outpatient">
                <div class="outpatientTitle">智慧门诊</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">智慧门诊简介</div>
                    <div class="outpatientContText">
                      展华智慧门诊系统，通过搭建患者服务平台，整合医疗资源，实现诊疗流程再造，把优化患者就医流程作为以患者为中心的切入点，充分应用各种成熟技术（如银行卡、条形码、自助机和微信公众号等），建立包括统一的预约平台、支付平台、查询平台，通过预约管理、自助缴费、导诊提醒、健康宣教、信息查询、咨询管理和投诉管理等模块建设，实现服务前移，全面提升为患者服务的质量。
                    </div>
                    <div class="outpatientImg">
                      <img :src="outpatienta" />
                      <div class="line">— 各平台系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <span></span>
                    <li>
                      <span>移动端功能：</span
                      >预约挂号，预约报到，当日挂号，就诊提醒，门诊缴费，检查检验报告查询，挂号记录查询，健康资讯查阅，医院介绍，专家介绍，个人中心，满意度评价等功能。
                    </li>
                    <li>
                      <span>自助终端软件：</span
                      >签约建档，预约挂号，当日挂号，预约报到，自助缴费，自助查询，报告查看、诊史查询、健康资讯查阅，医院送，短信通知等功能。
                    </li>
                    <li>
                      <span>其他功能：</span
                      >门诊预约挂号平台，智能分针平台（排队叫号），统一支付平台（门诊部分），统一对账平台（门诊部分），消息推送，短信通知等功能。
                    </li>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <div class="trait">
                      <li>线上、线下一体化</li>
                      <li>分时段预约</li>
                      <li>自助取号</li>
                      <li>自助缴费</li>
                      <li>随时查看就医档案</li>
                      <li>提升就医感受</li>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </el-tab-pane>
            <el-tab-pane 
              > <span slot="label" @click="tab(2)">
                <i class="el-icon-caret-right"></i> 智慧住院
             </span >
              <div class="outpatient">
                <div class="outpatientTitle">智慧住院</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">智慧住院简介</div>
                    <div class="outpatientContText">
                      展华智慧住院系统，延续智慧门诊产品特点，将智慧管理延申到医院住院管理业务的各个环节。内容包括智慧住院微信公众号系统、住院支付平台、住院统一对账平台、自助一体机软件系统。
                    </div>
                    <div class="outpatientImg">
                      <img :src="outpatientb" />
                      <div class="line">— 各平台系统截图 —</div>
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <span></span>
                    <li>
                      <span>移动端及自助终端功能：</span
                      >自助终端软件，微信公众号（住院部分），身份确认系统，线上自助入院建档，预约住院，住院预交金管理，信息推送，满意度评价，健康宣教，营养订餐等功能。
                    </li>
                    <li>
                      <span>其他功能：</span
                      >病历复印预约，病区床位管理，住院业务管理（统计分析），医院运营监控，统一支付平台(住院部分)，统一对账平台(住院部分)，患者信息共享，统计等功能。
                    </li>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要特点</div>
                    <div class="trait">
                      <li>一体化管理</li>
                      <li>院前-住院预约</li>
                      <li>院中-各类床旁服务</li>
                      <li>院后-满意度调查、患者随访</li>
                    </div>
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
            <el-tab-pane 
              >
               <span slot="label"  @click="tab(3)">
                <i class="el-icon-caret-right"></i> 智慧护理
             </span >
              <div class="outpatient">
                <div class="outpatientTitle">智慧护理</div>
                <div class="outpatientCont">
                  <div class="outpatientConBox">
                    <div class="intro">智慧护理简介</div>
                    <div class="outpatientContText">
                      以护理管理信息平台基础结构为核心，包括临床护理、护理文书、护理管理等模块，涵盖了医嘱执行、护理计划、护理评估、护理记录、统计分析等内容，覆盖护理工作全流程。
                      <br/>系统功能涵盖身份核对、医嘱提示、医嘱审核、医嘱执行、生命体征采集、药品核对、检验检查处理及查询、护理文书处理、工作量统计等各工作环节，利用移动计算、智能识别、数据融合技术，实现全条码化移动式处理，帮助护理人员提高工作效率和服务质量，提高病人满意度。
                    </div>
                  </div>
                  <div class="outpatientConBox">
                    <div class="outpatientContTitle">系统主要功能</div>
                    <span></span>
                    <li>
                      <span>护理临床</span>
                      <div class="nursing">
                        <span> 医嘱执行:</span>
                       首先将每一项医嘱进行三级分解，直到每一次护理行为，再将每一次护理行为按照实际工作顺序和护理规范形成一个闭环管理流程，最后通过移动技术和软硬件设备实现信息化管理。如“静脉注射”、“骨折牵引治疗”等。
                      </div>
                      <div class="nursing">
                        <span> 护嘱执行：</span>
                        对于没有医嘱派生的单纯护理工作，我们创建了护嘱概念，并形成以护嘱为指南的闭环管理。如“入院评估”、“压疮护理”等。
                      </div>
                       <div class="nursing">
                        <span> 护理路径：</span>
                        根据各个不同病种和患者状况，予以“护理诊断”，从而形成“护理路径”，规范全程护理工作，提高护理质量，减少差错事故。
                      </div>
                    </li>
                    <li>
                      <span>护理文书</span>
                     <div class="nursing">
                        主要分为“护理评估”、“护理记录”、“教育宣讲”、“生命体征”、“其他特殊记录”五大类。
                      </div>
                    </li>
                    
                  </div>
                </div>
                <div></div></div
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
     <footer>
    <Root/>
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue"
import productBanner from "../../assets/productBanner.png";
import outpatienta from "../../assets/outpatienta.png";
import outpatientb from "../../assets/outpatientb.png";
export default {
  name: "service",
   components: {
    Navbar,Root,
  },
  data() {
   
    return {
       current:1,
      tabPosition: "left",
      productBanner: productBanner,
      outpatienta: outpatienta,
      outpatientb: outpatientb,
    };
  },
  methods: {
    tab(index){
      this.current=index;
    },
  },
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");

footer{
  height: 520px;
  margin-top: 30px;
}
header{
 background-color: #ffffff;
}
.product {
  background-color: #f5f7fa;
  width: 100%;
  overflow: hidden;

  font-family: PingFangSC-Medium;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/productBanner.png") no-repeat;
  background-position:center;
  background-size: cover;
}
/* .productBanner {
  width: 1920px;
  left: 50%;
  margin-left: -960px;
  position: relative;
} */
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  width: 64%;
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.productCont {
  width: 85%;
  margin: 0 auto;
}
.crumbs {
  margin-top: 25px;
  margin-bottom: 30px;
}
.crumbs .el-breadcrumb {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 22px;
  font-weight: 400;
}
.tabsCont {
  width: 95%;
  margin: 0 auto;
  position: relative;
}
.tabTitle {
  position: absolute;
  top: 35px;
  z-index: 100;
  width: 20%;
}
.tabTitle :nth-child(1) {
  font-size: 20px;
  margin: 0 auto;
  height: 50px;
  border-bottom: 1px solid #e9eaee;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.tabTitle :nth-child(2) {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  margin-top: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}
.outpatient {
  width: 90%;
  margin: 0 auto;
}
.outpatientTitle {
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  height: 55px;
  border-bottom: 1px solid #e9eaee;
}
.outpatientConBox {
  width: 100%;
  margin: 0 auto;
}
.outpatientImg {
  width: 100%;
  text-align: center;

  margin: 0 auto;
}
.outpatientImg img {
  margin-top: 50px;
}
.tabs .el-tabs {
  height: 100% !important;
}
.outpatientContTitle {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 50px;
  margin-bottom: 28px;
}
.outpatientContText {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  line-height: 26px;
  font-weight: 400;
  margin-top: 20px;
}
.intro {
  font-size: 20px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 66px;
  margin-bottom: 28px;
}
.a {
  position: relative;
  z-index: 1;
}
.el-icon-caret-right {
  color: #ffffff;
  margin-left: -20px;
}
.outpatientImg .line {
  font-size: 14px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: center;
  line-height: 26px;
  font-weight: 200;
  margin-top: 10px;
}
.outpatientConBox li {
  font-size: 16px;
  margin-bottom: 16px;
  /* margin-top: 30px; */
  color: #3d455f;
  letter-spacing: 0;
  font-weight: 400;
}
.outpatientConBox li span {
  color: #0f1422;
  font-weight: 500;
}
.trait {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
justify-content: space-between 
}
.traits {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 400;
  /* justify-content: flex-start; */
  /* justify-content: space-around; */
  justify-content: space-between;
}
.trait:after {content: ""; width: 50%; } 
.traits:after {content: ""; width: 50%; }  
.traits li {
  width: 20%;
}
.nursing {
  text-indent: 1em;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 400;
  margin-top: 16px;
}
.nursing span {
  color: #29324c;
}
.tabsCont >>> .el-tabs__header {
  width: 20% !important;
  background-color: #ffffff;
  padding-top: 120px;
}
.tabsCont >>> .el-tabs__content {
  border-left: #f5f7fa 8px solid;

  background-color: #ffffff;
}
.tabsCont >>> .el-radio-group {
  margin: 0;
}
.tabsCont >>> .el-tabs__item {
  text-align: left;
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
width: 95%;
  font-weight: 400;
}
.tabsCont >>> .el-tabs__item.is-active {
  text-align: left;
  font-size: 16px;
  width: 95%;
  background-color: #e52f22;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
.tabsCont >>> .el-tabs__item {
text-align: left  !important;
}
</style>



// WEBPACK FOOTER //
// src/views/service/index.vue